import { createAction, props } from '@ngrx/store';
import {
	RebateGroupAggregatorNdcSearchModel,
	SearchResponse,
	RebateGroupAggregatorNdcModel,
	CreateRebateGroupAggregatorNdcModel,
	UpdateRebateGroupAggregatorNdcModel,
	FilterSearchRequest,
	BaseSearchColumnFilterModel,
	BulkUpdateRebateGroupAggregatorNdcModel,
	RebateGroupAggregatorNdcFilterModel
} from '@twrx-api-models';
import { IPreLoadModel } from 'app/models/dto/pre-load-model';

import { ActionRequestPayload } from '../action-request-payload';
import { ActionResponsePayload } from '../action-response-payload';

export enum RebateGroupAggregatorNdcActions {
	LoadRebateGroupAggregatorNdcs = '[Rebate Group Aggregator Ndc] LoadRebateGroupAggregatorNdcs',
	RebateGroupAggregatorNdcsLoaded = '[Rebate Group Aggregator Ndc] RebateGroupAggregatorNdcsLoaded',

	PreloadRebateGroupAggregatorNdc = '[Rebate Group Aggregator Ndc] PreloadRebateGroupAggregatorNdc',
	RebateGroupAggregatorNdcPreloaded = '[Rebate Group Aggregator Ndc] RebateGroupAggregatorNdcPreloaded',
	PreloadRebateGroupAggregatorNdcNotFound = '[Rebate Group Aggregator Ndc] PreloadRebateGroupAggregatorNdcNotFound',

	LoadRebateGroupAggregatorNdcById = '[Rebate Group Aggregator Ndc] LoadRebateGroupAggregatorNdcById',
	LoadRebateGroupAggregatorNdcLoaded = '[Rebate Group Aggregator Ndc] LoadRebateGroupAggregatorNdcLoaded',
	LoadRebateGroupAggregatorNdcNotFound = '[Rebate Group Aggregator Ndc] LoadRebateGroupAggregatorNdcNotFound',

	CreateRebateGroupAggregatorNdc = '[Rebate Group Aggregator Ndc] CreateRebateGroupAggregatorNdc',
	RebateGroupAggregatorNdcCreated = '[Rebate Group Aggregator Ndc] RebateGroupAggregatorNdcCreated',

	UpdateRebateGroupAggregatorNdc = '[Rebate Group Aggregator Ndc] UpdateRebateGroupAggregatorNdc',
	RebateGroupAggregatorNdcUpdated = '[Rebate Group Aggregator Ndc] RebateGroupAggregatorNdcUpdated',

	DeleteRebateGroupAggregatorNdc = '[Rebate Group Aggregator Ndc] DeleteRebateGroupAggregatorNdc',
	RebateGroupAggregatorNdcDeleted = '[Rebate Group Aggregator Ndc] RebateGroupAggregatorNdcDeleted',

	StartRebateGroupAggregatorNdcFileGeneration = '[Rebate Group Aggregator Ndc] StartRebateGroupAggregatorNdcFileGeneration',
	RebateGroupAggregatorNdcFileGenerationStarted = '[Rebate Group Aggregator Ndc] RebateGroupAggregatorNdcFileGenerationStarted',

	StartRebateGroupAggregatorNdcFilteredFileGeneration = '[Rebate Group Aggregator Ndc] StartRebateGroupAggregatorNdcFilteredFileGeneration',
	RebateGroupAggregatorNdcFilteredFileGenerationStarted = '[Rebate Group Aggregator Ndc] RebateGroupAggregatorNdcFilteredFileGenerationStarted',

	BulkUpdateRebateGroupAggregatorNdc = '[Rebate Group Aggregator Ndc] BulkUpdateRebateGroupAggregatorNdc',
	RebateGroupAggregatorNdcBulkUpdated = '[Rebate Group Aggregator Ndc] RebateGroupAggregatorNdcBulkUpdated',

	ErrorOccurred = '[Rebate Group Aggregator Ndc] ErrorOccurred'
}

export const loadRebateGroupAggregatorNdcs = createAction(
	RebateGroupAggregatorNdcActions.LoadRebateGroupAggregatorNdcs,
	props<
		ActionRequestPayload<FilterSearchRequest<BaseSearchColumnFilterModel>>
	>()
);

export const rebateGroupAggregatorNdcsLoaded = createAction(
	RebateGroupAggregatorNdcActions.RebateGroupAggregatorNdcsLoaded,
	props<
		ActionResponsePayload<
			SearchResponse<RebateGroupAggregatorNdcSearchModel>
		>
	>()
);

export const preloadRebateGroupAggregatorNdc = createAction(
	RebateGroupAggregatorNdcActions.PreloadRebateGroupAggregatorNdc,
	props<ActionRequestPayload<IPreLoadModel<number>>>()
);

export const rebateGroupAggregatorNdcPreloaded = createAction(
	RebateGroupAggregatorNdcActions.RebateGroupAggregatorNdcPreloaded,
	props<ActionResponsePayload<IPreLoadModel<RebateGroupAggregatorNdcModel>>>()
);

export const preloadRebateGroupAggregatorNdcNotFound = createAction(
	RebateGroupAggregatorNdcActions.PreloadRebateGroupAggregatorNdcNotFound
);

export const loadRebateGroupAggregatorNdcById = createAction(
	RebateGroupAggregatorNdcActions.LoadRebateGroupAggregatorNdcById,
	props<ActionRequestPayload<number>>()
);

export const loadRebateGroupAggregatorNdcLoaded = createAction(
	RebateGroupAggregatorNdcActions.LoadRebateGroupAggregatorNdcLoaded,
	props<ActionResponsePayload<RebateGroupAggregatorNdcModel>>()
);

export const loadRebateGroupAggregatorNdcNotFound = createAction(
	RebateGroupAggregatorNdcActions.LoadRebateGroupAggregatorNdcNotFound
);

export const createRebateGroupAggregatorNdc = createAction(
	RebateGroupAggregatorNdcActions.CreateRebateGroupAggregatorNdc,
	props<ActionRequestPayload<CreateRebateGroupAggregatorNdcModel>>()
);

export const rebateGroupAggregatorNdcCreated = createAction(
	RebateGroupAggregatorNdcActions.RebateGroupAggregatorNdcCreated
);

export const updateRebateGroupAggregatorNdc = createAction(
	RebateGroupAggregatorNdcActions.UpdateRebateGroupAggregatorNdc,
	props<ActionRequestPayload<UpdateRebateGroupAggregatorNdcModel>>()
);

export const rebateGroupAggregatorNdcUpdated = createAction(
	RebateGroupAggregatorNdcActions.RebateGroupAggregatorNdcUpdated
);

export const deleteRebateGroupAggregatorNdc = createAction(
	RebateGroupAggregatorNdcActions.DeleteRebateGroupAggregatorNdc,
	props<ActionRequestPayload<number>>()
);

export const rebateGroupAggregatorNdcDeleted = createAction(
	RebateGroupAggregatorNdcActions.RebateGroupAggregatorNdcDeleted
);

export const startRebateGroupAggregatorNdcFileGeneration = createAction(
	RebateGroupAggregatorNdcActions.StartRebateGroupAggregatorNdcFileGeneration,
	props<ActionRequestPayload<void>>()
);

export const rebateGroupAggregatorNdcFileGenerationStarted = createAction(
	RebateGroupAggregatorNdcActions.RebateGroupAggregatorNdcFileGenerationStarted
);

export const startRebateGroupAggregatorNdcFilteredFileGeneration = createAction(
	RebateGroupAggregatorNdcActions.StartRebateGroupAggregatorNdcFilteredFileGeneration,
	props<
		ActionRequestPayload<
			FilterSearchRequest<RebateGroupAggregatorNdcFilterModel>
		>
	>()
);

export const rebateGroupAggregatorNdcFilteredFileGenerationStarted =
	createAction(
		RebateGroupAggregatorNdcActions.RebateGroupAggregatorNdcFilteredFileGenerationStarted
	);

export const bulkUpdateRebateGroupAggregatorNdc = createAction(
	RebateGroupAggregatorNdcActions.BulkUpdateRebateGroupAggregatorNdc,
	props<ActionRequestPayload<BulkUpdateRebateGroupAggregatorNdcModel>>()
);

export const rebateGroupAggregatorNdcBulkUpdated = createAction(
	RebateGroupAggregatorNdcActions.RebateGroupAggregatorNdcBulkUpdated
);

export const errorOccurred = createAction(
	RebateGroupAggregatorNdcActions.ErrorOccurred
);
